var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Fire = function Fire(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.617 2.076a1 1 0 0 1 1.09.217c.657.657 1.48 2.094 1.888 3.73.341 1.368.426 3.02-.237 4.567.021-.005.039-.012.055-.019.116-.046.326-.176.634-.52.305-.34.665-.842 1.094-1.563a1 1 0 0 1 1.606-.153c.573.644 1.125 1.622 1.531 2.607.405.98.722 2.104.722 3.058a7 7 0 1 1-14 0c0-2.01.868-4.243 2.283-5.697v-.001l.098-.1C8.607 6.946 10 5.52 10 3a1 1 0 0 1 .617-.924Zm.853 3.803c-.655 1.676-1.782 2.827-2.6 3.662l-.154.157L8 9l.717.697C7.68 10.763 7 12.49 7 14a5 5 0 1 0 10 0c0-.578-.21-1.423-.57-2.296a10.239 10.239 0 0 0-.422-.898c-.16.214-.317.407-.472.58-.42.47-.872.84-1.381 1.043-1.159.463-2.115-.098-2.792-.658a1 1 0 0 1-.192-1.33c.783-1.159.82-2.583.484-3.934a7.915 7.915 0 0 0-.185-.628Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Fire;